import { render, staticRenderFns } from "./Enfranchisement.vue?vue&type=template&id=89e1a5d8&"
import script from "./Enfranchisement.vue?vue&type=script&lang=js&"
export * from "./Enfranchisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports